<template>
  <keep-alive include="couponsList">
    <router-view ></router-view>
  </keep-alive>
</template>

<script>
  export default {
    name: "UserCoupons",
    created() {
      if (!this.common.loginInfo.isLogin){
        this.$router.push("/login")
      }
    }
  }
</script>

<style scoped>

</style>
